import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import {
  requestCreateSpecification,
  requestViewAllMetricUnits,
  requestUpdateType,
} from '../../../../api/product/product.actions';
import { requestViewAllFacilitators } from '../../../../api/party/party.actions';

import ProductTypeModal from '../../../../components/screens/admin/product-specifications/product-type-modal/ProductTypeModal';

const ProductTypeModalContainer = ({
  show,
  setShow,
  filters,
  specification,
  retrieveSpecifications,
  retrieveCategories,
  retrieveTypes,
  onHide,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(requestViewAllMetricUnits());
    dispatch(requestViewAllFacilitators());
  }, [dispatch]);

  const createType = (specification, onSuccess) => {
    dispatch(
      requestCreateSpecification({
        specification,
        onSuccess: () => {
          retrieveSpecifications(filters);

          if (filters.categoryExternalReference) {
            retrieveTypes(filters.categoryExternalReference);
          }

          onSuccess();
        },
      })
    );
  };

  const updateType = (type, onSuccess) => {
    dispatch(
      requestUpdateType({
        type,
        onSuccess: () => {
          retrieveSpecifications(filters);

          if (filters.categoryExternalReference) {
            retrieveTypes(filters.categoryExternalReference);
          }

          onSuccess();
        },
      })
    );
  };

  return (
    <ProductTypeModal
      show={show}
      setShow={setShow}
      specification={specification}
      retrieveCategories={retrieveCategories}
      createType={createType}
      updateType={updateType}
      onHide={onHide}
    />
  );
};

ProductTypeModalContainer.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  filters: PropTypes.shape({}).isRequired,
  specification: PropTypes.shape({}),
  retrieveSpecifications: PropTypes.func.isRequired,
  retrieveCategories: PropTypes.func.isRequired,
  retrieveTypes: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

ProductTypeModalContainer.defaultProps = {
  specification: undefined,
};

export default ProductTypeModalContainer;
